import { createSelector } from "@reduxjs/toolkit";
import { CURRENCY_FEATURE_KEY } from "./shared-geo-data-feature-keys.js";
const EMPTY_STATE = {};
const getCurrencyState = (rootState) => rootState[CURRENCY_FEATURE_KEY] || EMPTY_STATE;
const selectExchangeRates = createSelector(
  getCurrencyState,
  (s) => s.exchangeRates
);
const selectExchangeRatesByCode = createSelector(
  selectExchangeRates,
  (_rates, codeFrom) => codeFrom,
  (_rates, codeFrom, codeTo) => codeTo,
  (rates, codeFrom, codeTo) => {
    var _a;
    if (!rates) return null;
    const directRate = rates.find(
      (rate) => rate.codeFrom === codeFrom && rate.codeTo === codeTo
    );
    if (directRate) {
      return directRate;
    }
    const baseCurrency = (_a = rates[0]) == null ? void 0 : _a.codeFrom;
    if (codeTo === baseCurrency) {
      const baseToFrom = rates.find(
        (rate) => rate.codeFrom === baseCurrency && rate.codeTo === codeFrom
      );
      if (baseToFrom) {
        return {
          codeFrom,
          codeTo,
          value: 1 / baseToFrom.value
        };
      }
    }
    if (codeFrom !== baseCurrency && codeTo !== baseCurrency) {
      const baseToFrom = rates.find(
        (rate) => rate.codeFrom === baseCurrency && rate.codeTo === codeFrom
      );
      const baseToTo = rates.find(
        (rate) => rate.codeFrom === baseCurrency && rate.codeTo === codeTo
      );
      if (baseToFrom && baseToTo) {
        return {
          codeFrom,
          codeTo,
          value: baseToTo.value / baseToFrom.value
        };
      }
    }
    return null;
  }
);
export {
  getCurrencyState,
  selectExchangeRates,
  selectExchangeRatesByCode
};
